// src/pages/Learning.js
import React from "react";
import NavBar from "../components/NavBar/NavBar";
import LearningModules from "../components/LearningModules/LearningModules";

const Learning = () => {
  return (
    <>
      <NavBar/>
      <main className="web-view">
        <LearningModules/>
      </main>
    </>
  );
};

export default Learning;
